import api from "@/lib/api";
import { LeadResponse } from "@/types/api";
import { debugNetworkRequest, debugApiError } from "@/utils/chatDebug";
import { leadsLogger } from "@/utils/logger";

export const leadService = {
  // Buscar lead por ID
  async getLeadById(id: string): Promise<LeadResponse> {
    try {
      debugNetworkRequest(`/leads/${id}`, "GET");

      const response = await api.get<LeadResponse>(`/leads/${id}`);

      leadsLogger.log("✅ Lead carregado:", response.data.id);

      return response.data;
    } catch (error) {
      debugApiError(error, "getLeadById");
      throw error;
    }
  },

  // Buscar múltiplos leads por IDs (BATCH)
  async getLeadsByIds(ids: string[]): Promise<LeadResponse[]> {
    try {
      if (ids.length === 0) return [];

      const requestData = { ids };

      debugNetworkRequest("/leads/batch", "POST", requestData);

      const response = await api.post<LeadResponse[]>(
        "/leads/batch",
        requestData
      );

      leadsLogger.log(
        "✅ Leads carregados em batch:",
        response.data.length,
        "de",
        ids.length,
        "solicitados"
      );

      // Debug dos primeiros leads
      if (response.data.length > 0) {
        leadsLogger.log("🔍 Primeiro lead:", response.data[0]);
      }

      return response.data;
    } catch (error) {
      debugApiError(error, "getLeadsByIds");
      throw error;
    }
  },

  // Listar todos os leads (se necessário)
  async getLeads(): Promise<LeadResponse[]> {
    try {
      debugNetworkRequest("/leads", "GET");

      const response = await api.get<LeadResponse[]>("/leads");

      leadsLogger.log("✅ Todos os leads carregados:", response.data.length);

      return response.data;
    } catch (error) {
      debugApiError(error, "getLeads");
      throw error;
    }
  },

  // Criar novo lead
  async createLead(data: {
    name: string;
    email: string;
    waId: string;
  }): Promise<LeadResponse> {
    try {
      debugNetworkRequest("/leads", "POST", data);
      const response = await api.post<LeadResponse>("/leads", data);
      return response.data;
    } catch (error) {
      debugApiError(error, "createLead");
      throw error;
    }
  },

  // Atualizar lead existente
  async updateLead(
    id: string,
    data: { name: string; email: string; waId: string }
  ): Promise<LeadResponse> {
    try {
      debugNetworkRequest(`/leads/${id}`, "PUT", data);
      const response = await api.put<LeadResponse>(`/leads/${id}`, data);
      return response.data;
    } catch (error) {
      debugApiError(error, "updateLead");
      throw error;
    }
  },
};
